module.exports = __webpack_public_path__ + "static/media/basketTitle.cb5be871.png";